import { Alert, Box, Link, Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

export const NoCostCentersAlert = ({ hasCostCenters }: { hasCostCenters: boolean }) => {
  const { navigation } = useNavigation()

  return (
    <Alert color="warning">
      <Box flexDirection="column" gap="s16">
        <Text.Normal size="300" weight="medium">
          {i18n.t('finance.employee_cost_centers_info.tip.title')}
        </Text.Normal>
        {hasCostCenters && (
          <Link.Router to={navigation.settings.finance.costCenters.fullPath()}>
            {i18n.t('finance.employee_cost_centers_info.tip.link')}
          </Link.Router>
        )}
      </Box>
    </Alert>
  )
}
